// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  server_url: "https://ncommerce.app:3001", // "https://ncommerce.app:3001", // "https://ncommerce.app:3001", // "https://ncommerce.app:3001" or "http://localhost:3001" or "http://172.17.1.197:3001"
  api_url: "",
  ncommerce_wapp: "5562991120271",
  // Public site key from Cloudflare Turnstile (Invisible widget). Leave empty until the widget exists.
  turnstile_site_key: "0x4AAAAAAEsOwQsF-VTUIkrI",
  // "Sign in with Google" (Google Identity Services); same as GOOGLE_CLIENT_ID on the server.
  google_client_id: "687494538604-bn04hulpl956191binspj182llu4vgg3.apps.googleusercontent.com"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
